import React from 'react';

import { Check, ChevronDown } from 'lucide-react';

import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '#/components/ui';
import { cn } from '#/utils';

const ComboBox = ({ value, onChange, placeholder = 'Search', options = [] }) => {
    const handleOptionChange = value => () => onChange(value);
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant='outline'
                    role='combobox'
                    className={cn(
                        'w-full px-4 py-3 border bg-transparent border-borderGray font-normal text-left rounded-lg shadow-sm justify-between',
                        value ? 'text-gray700 capitalize' : 'text-gray400'
                    )}
                >
                    {value || placeholder}
                    <ChevronDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-[480px] p-0 bg-white'>
                <Command>
                    <CommandInput placeholder={`${placeholder}...`} />
                    <CommandList>
                        <CommandEmpty>No result found.</CommandEmpty>
                        <CommandGroup>
                            {options.map(option => (
                                <CommandItem
                                    key={option.value}
                                    onSelect={handleOptionChange(option.value)}
                                    className='capitalize cursor-pointer hover:bg-gray100'
                                >
                                    <Check
                                        className={cn(
                                            'mr-2 h-4 w-4',
                                            value === option.value ? 'opacity-100' : 'opacity-0'
                                        )}
                                    />
                                    {option.label}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
};

export { ComboBox };
